module.exports = __webpack_public_path__ + "assets/62a96977e725e8bc809dc80afe0fedf1.js";